module.exports = __webpack_public_path__ + "img/Group7.5406c85a.svg";